<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <component v-if="theme == 'dark'" :is="'style'">
      .gm-style-iw{ background-color: #2A3042 !important; } .gm-style-iw-d{
      overflow: auto !important; } .gm-style-iw-t::after{ background-color:
      #2A3042 !important; }
    </component>

    <b-row class="mb-2">
      <b-col>
        <div class="card">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-title
              "
            >
              <span class="badge bg-primary p-1 mr-1">
                <i class="text-white mdi mdi-18px mdi-map-marker"></i>
              </span>
              <strong>CCTV 1</strong>
              <div v-if="activecctv.cctv1.is_active == true">
                <i
                  v-b-modal.modal-cctv1
                  class="mdi mdi-24px mdi-fullscreen"
                ></i>
                <i
                  @click="setNonActive(activecctv.cctv1.cctvdata.id)"
                  class="cursor-pointer mdi mdi-24px mdi-close"
                ></i>
              </div>
            </div>
            <img
              v-if="activecctv.cctv1.is_active == true && !hls.cctv1"
              :src="activecctv.cctv1.cctvdata.link"
              width="260px"
              height="150px"
              class="cctv"
              alt="cctv 1"
              @error="imageError('cctv1', activecctv.cctv1.cctvdata.link)"
            />
            <video-player
              v-if="activecctv.cctv1.is_active == true && hls.cctv1"
              ref="videoPlayer1"
              class="vjs-custom-skin"
              width="260px"
              height="150px"
              :options="playerOptions"
            />
          </div>
        </div>
        <b-modal
          id="modal-cctv1"
          size="xl"
          centered
          :title="'CCTV 1 - ' + activecctv.cctv1.cctvdata.name"
          title-class="font-18"
          hide-footer
          @show="videoModal(1, activecctv.cctv1.cctvdata.link)"
        >
          <img
            v-if="!hls.cctv1"
            :src="activecctv.cctv1.cctvdata.link"
            width="100%"
            height="auto"
            class="cctv"
            alt="cctv 1"
          />
          <video-player
            v-else
            ref="videoPlayer1Modal"
            class="vjs-custom-skin"
            :options="playerOptionsModal"
          />
        </b-modal>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-title
              "
            >
              <span class="badge bg-success p-1 mr-1">
                <i class="text-white mdi mdi-18px mdi-map-marker"></i>
              </span>
              <strong>CCTV 2</strong>
              <div v-if="activecctv.cctv2.is_active == true">
                <i
                  v-b-modal.modal-cctv2
                  class="mdi mdi-24px mdi-fullscreen"
                ></i>
                <i
                  @click="setNonActive(activecctv.cctv2.cctvdata.id)"
                  class="cursor-pointer mdi mdi-24px mdi-close"
                ></i>
              </div>
            </div>
            <img
              v-if="activecctv.cctv2.is_active == true && !hls.cctv2"
              :src="activecctv.cctv2.cctvdata.link"
              width="260px"
              height="150px"
              class="cctv"
              alt="cctv 2"
              @error="imageError('cctv2', activecctv.cctv2.cctvdata.link)"
            />
            <video-player
              v-if="activecctv.cctv2.is_active == true && hls.cctv2"
              ref="videoPlayer2"
              class="vjs-custom-skin"
              width="260px"
              height="150px"
              :options="playerOptions"
            />
          </div>
        </div>
        <b-modal
          id="modal-cctv2"
          size="xl"
          centered
          :title="'CCTV 2 - ' + activecctv.cctv2.cctvdata.name"
          title-class="font-18"
          hide-footer
          @show="videoModal(2, activecctv.cctv2.cctvdata.link)"
        >
          <img
            v-if="!hls.cctv2"
            :src="activecctv.cctv2.cctvdata.link"
            width="100%"
            height="auto"
            class="cctv"
            alt="cctv 2"
          />
          <video-player
            v-else
            ref="videoPlayer2Modal"
            class="vjs-custom-skin"
            :options="playerOptionsModal"
          />
        </b-modal>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-title
              "
            >
              <span class="badge bg-warning p-1 mr-1">
                <i class="text-white mdi mdi-18px mdi-map-marker"></i>
              </span>
              <strong>CCTV 3</strong>
              <div v-if="activecctv.cctv3.is_active == true">
                <i
                  v-b-modal.modal-cctv3
                  class="mdi mdi-24px mdi-fullscreen"
                ></i>
                <i
                  @click="setNonActive(activecctv.cctv3.cctvdata.id)"
                  class="cursor-pointer mdi mdi-24px mdi-close"
                ></i>
              </div>
            </div>
            <img
              v-if="activecctv.cctv3.is_active == true && !hls.cctv3"
              :src="activecctv.cctv3.cctvdata.link"
              width="260px"
              height="150px"
              class="cctv"
              alt="cctv 3"
              @error="imageError('cctv3', activecctv.cctv3.cctvdata.link)"
            />
            <video-player
              v-if="activecctv.cctv3.is_active == true && hls.cctv3"
              ref="videoPlayer3"
              class="vjs-custom-skin"
              width="260px"
              height="150px"
              :options="playerOptions"
            />
          </div>
        </div>
        <b-modal
          id="modal-cctv3"
          size="xl"
          centered
          :title="'CCTV 3 - ' + activecctv.cctv3.cctvdata.name"
          title-class="font-18"
          hide-footer
          @show="videoModal(3, activecctv.cctv3.cctvdata.link)"
        >
          <img
            v-if="!hls.cctv3"
            :src="activecctv.cctv3.cctvdata.link"
            width="100%"
            height="auto"
            class="cctv"
            alt="cctv 3"
          />
          <video-player
            v-else
            ref="videoPlayer3Modal"
            class="vjs-custom-skin"
            :options="playerOptionsModal"
          />
        </b-modal>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-title
              "
            >
              <span class="badge bg-purple p-1 mr-1">
                <i class="text-white mdi mdi-18px mdi-map-marker"></i>
              </span>
              <strong>CCTV 4</strong>
              <div v-if="activecctv.cctv4.is_active == true">
                <i
                  v-b-modal.modal-cctv4
                  class="mdi mdi-24px mdi-fullscreen"
                ></i>
                <i
                  @click="setNonActive(activecctv.cctv4.cctvdata.id)"
                  class="cursor-pointer mdi mdi-24px mdi-close"
                ></i>
              </div>
            </div>
            <img
              v-if="activecctv.cctv4.is_active == true && !hls.cctv4"
              :src="activecctv.cctv4.cctvdata.link"
              width="260px"
              height="150px"
              class="cctv"
              alt="cctv 4"
              @error="imageError('cctv4', activecctv.cctv4.cctvdata.link)"
            />
            <video-player
              v-if="activecctv.cctv4.is_active == true && hls.cctv4"
              ref="videoPlayer4"
              class="vjs-custom-skin"
              width="260px"
              height="150px"
              :options="playerOptions"
            />
          </div>
        </div>
        <b-modal
          id="modal-cctv4"
          size="xl"
          centered
          :title="'CCTV 4 - ' + activecctv.cctv4.cctvdata.name"
          title-class="font-18"
          hide-footer
          @show="videoModal(4, activecctv.cctv4.cctvdata.link)"
        >
          <img
            v-if="!hls.cctv4"
            :src="activecctv.cctv4.cctvdata.link"
            width="100%"
            height="auto"
            class="cctv"
            alt="cctv 4"
          />
          <video-player
            v-else
            ref="videoPlayer4Modal"
            class="vjs-custom-skin"
            :options="playerOptionsModal"
          />
        </b-modal>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-title
              "
            >
              <span class="badge bg-info p-1 mr-1">
                <i class="text-white mdi mdi-18px mdi-map-marker"></i>
              </span>
              <strong>CCTV 5</strong>
              <div v-if="activecctv.cctv5.is_active == true">
                <i
                  v-b-modal.modal-cctv5
                  class="mdi mdi-24px mdi-fullscreen"
                ></i>
                <i
                  @click="setNonActive(activecctv.cctv5.cctvdata.id)"
                  class="cursor-pointer mdi mdi-24px mdi-close"
                ></i>
              </div>
            </div>
            <img
              v-if="activecctv.cctv5.is_active == true && !hls.cctv5"
              :src="activecctv.cctv5.cctvdata.link"
              width="260px"
              height="150px"
              class="cctv"
              alt="cctv 5"
              @error="imageError('cctv5', activecctv.cctv5.cctvdata.link)"
            />
            <video-player
              v-if="activecctv.cctv5.is_active == true && hls.cctv5"
              ref="videoPlayer5"
              class="vjs-custom-skin"
              width="260px"
              height="150px"
              :options="playerOptions"
            />
          </div>
        </div>
        <b-modal
          id="modal-cctv5"
          size="xl"
          centered
          :title="'CCTV 5 - ' + activecctv.cctv5.cctvdata.name"
          title-class="font-18"
          hide-footer
          @show="videoModal(5, activecctv.cctv5.cctvdata.link)"
        >
          <img
            v-if="!hls.cctv5"
            :src="activecctv.cctv5.cctvdata.link"
            width="100%"
            height="auto"
            class="cctv"
            alt="cctv 5"
          />
          <video-player
            v-else
            ref="videoPlayer5Modal"
            class="vjs-custom-skin"
            :options="playerOptionsModal"
          />
        </b-modal>
      </b-col>
    </b-row>
    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <gmap-map
              ref="mymap"
              :center="center"
              :zoom="zoom"
              :options="mapTheme()"
              style="height: 80vh"
              @click="measureDistance"
              @zoom_changed="test"
            >
              <div
                ref="custom"
                class="d-flex flex-column items-center custom-control"
              >
                <button
                  title="Measure Distance"
                  class="btn mb-2 mr-2 px-2 py-2 text-xs bg-white"
                  @click="distanceMode()"
                >
                  <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                    <path
                      :fill="measure_distance == true ? '#0067AC' : '#525252'"
                      d="M6.5,8.11C5.61,8.11 4.89,7.39 4.89,6.5A1.61,1.61 0 0,1 6.5,4.89C7.39,4.89 8.11,5.61 8.11,6.5V6.5A1.61,1.61 0 0,1 6.5,8.11M6.5,2C4,2 2,4 2,6.5C2,9.87 6.5,14.86 6.5,14.86C6.5,14.86 11,9.87 11,6.5C11,4 9,2 6.5,2M17.5,8.11A1.61,1.61 0 0,1 15.89,6.5C15.89,5.61 16.61,4.89 17.5,4.89C18.39,4.89 19.11,5.61 19.11,6.5A1.61,1.61 0 0,1 17.5,8.11M17.5,2C15,2 13,4 13,6.5C13,9.87 17.5,14.86 17.5,14.86C17.5,14.86 22,9.87 22,6.5C22,4 20,2 17.5,2M17.5,16C16.23,16 15.1,16.8 14.68,18H9.32C8.77,16.44 7.05,15.62 5.5,16.17C3.93,16.72 3.11,18.44 3.66,20C4.22,21.56 5.93,22.38 7.5,21.83C8.35,21.53 9,20.85 9.32,20H14.69C15.24,21.56 16.96,22.38 18.5,21.83C20.08,21.28 20.9,19.56 20.35,18C19.92,16.8 18.78,16 17.5,16V16M17.5,20.5A1.5,1.5 0 0,1 16,19A1.5,1.5 0 0,1 17.5,17.5A1.5,1.5 0 0,1 19,19A1.5,1.5 0 0,1 17.5,20.5Z"
                    />
                  </svg>
                </button>
                <button
                  title="Point of Interest"
                  class="
                    btn
                    mb-2
                    mr-2
                    bg-white
                    px-2
                    py-2
                    text-xs
                    rounded-sm
                    shadow
                    hover:bg-gray-200
                    pointer
                  "
                  @click="poiView()"
                >
                  <img
                    :src="
                      poi == true
                        ? 'https://img.icons8.com/glyph-neue/24/24991f/point-of-interest.png'
                        : 'https://img.icons8.com/glyph-neue/24/525252/point-of-interest.png'
                    "
                  />
                </button>
              </div>
              <div ref="search_map" style="width: 20%" class="row mt-2">
                <div class="col-12">
                  <gmap-autocomplete placeholder="Search Address" class="form-control form-control-lg" @place_changed="getAddressData"></gmap-autocomplete>
                </div>
              </div>

              <gmap-cluster
                v-if="showCluster"
                :minimumClusterSize="2"
                :styles="[
                  {
                    url: require('@/assets/images/rec50.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  v-for="(mcctv, index) in cctvmap"
                  :key="index"
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(mcctv.lat),
                    lng: parseFloat(mcctv.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: setColor(mcctv.id)[0],
                    fillOpacity: 1,
                    strokeColor: setColor(mcctv.id)[1],
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                  @click="openMarker(mcctv.id, mcctv.lat, mcctv.lng, 20)"
                >
                  <gmap-info-window
                    :closeclick="true"
                    @closeclick="openMarker(null, mcctv.lat, mcctv.lng, 15)"
                    :opened="openMarkerId === mcctv.id"
                  >
                    <div class="p-2">
                      <h4>{{ mcctv.cctv_name }}</h4>
                      <div class="">
                        <span>Source : {{ mcctv.source }}</span> <br />
                        <span style="width: 200px">
                          Address : {{ mcctv.address }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center mt-2">
                        <input
                          type="checkbox"
                          name="active"
                          id="set_active"
                          :checked="setChecked(mcctv.id)"
                          @click="
                            setChecked(mcctv.id) == true
                              ? setNonActive(mcctv.id)
                              : setActive(
                                  mcctv.id,
                                  mcctv.link,
                                  mcctv.cctv_name,
                                  mcctv.lat,
                                  mcctv.lng
                                )
                          "
                        />
                        <span class="mx-2 font-medium">Set Active</span>
                      </div>
                    </div>
                  </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-cluster
                v-if="activecctv.cctv1.is_active && showMarkerCluster"
                :minimumClusterSize="1"
                :styles="[
                  {
                    url: require('@/assets/images/rec01.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(activecctv.cctv1.lat),
                    lng: parseFloat(activecctv.cctv1.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: '#0f0',
                    fillOpacity: 1,
                    strokeColor: '#0f2',
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                >
                  <gmap-info-window :closeclick="true"> </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-cluster
                v-if="activecctv.cctv2.is_active && showMarkerCluster"
                :minimumClusterSize="1"
                :styles="[
                  {
                    url: require('@/assets/images/rec02.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(activecctv.cctv2.lat),
                    lng: parseFloat(activecctv.cctv2.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: '#0f0',
                    fillOpacity: 1,
                    strokeColor: '#0f2',
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                >
                  <gmap-info-window :closeclick="true"> </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-cluster
                v-if="activecctv.cctv3.is_active && showMarkerCluster"
                :minimumClusterSize="1"
                :styles="[
                  {
                    url: require('@/assets/images/rec03.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(activecctv.cctv3.lat),
                    lng: parseFloat(activecctv.cctv3.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: '#0f0',
                    fillOpacity: 1,
                    strokeColor: '#0f2',
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                >
                  <gmap-info-window :closeclick="true"> </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-cluster
                v-if="activecctv.cctv4.is_active && showMarkerCluster"
                :minimumClusterSize="1"
                :styles="[
                  {
                    url: require('@/assets/images/rec04.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(activecctv.cctv4.lat),
                    lng: parseFloat(activecctv.cctv4.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: '#0f0',
                    fillOpacity: 1,
                    strokeColor: '#0f2',
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                >
                  <gmap-info-window :closeclick="true"> </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-cluster
                v-if="activecctv.cctv5.is_active && showMarkerCluster"
                :minimumClusterSize="1"
                :styles="[
                  {
                    url: require('@/assets/images/rec05.png'),
                    width: 50,
                    height: 50,
                    textSize: 12,
                    textColor: '#fff',
                    anchorText: [0, 0],
                  },
                ]"
                :zoomOnClick="true"
                class="clusterMap"
              >
                <gmap-marker
                  :visible="showMarker"
                  :position="{
                    lat: parseFloat(activecctv.cctv5.lat),
                    lng: parseFloat(activecctv.cctv5.lng),
                  }"
                  :icon="{
                    path: 'M 12 0 C 7 0 3 4 3 9 C 3 10.730469 3.515625 12.066406 4.410156 13.421875 L 11.054688 23.5 C 11.253906 23.804688 11.601562 24 12 24 C 12.398438 24 12.75 23.796875 12.945312 23.5 L 19.589844 13.421875 C 20.484375 12.066406 21 10.730469 21 9 C 21 4 17 0 12 0 Z M 12 13.996094 C 9.238281 13.996094 7 11.757812 7 8.992188 C 7 6.226562 9.238281 3.984375 12 3.984375 C 14.761719 3.984375 17 6.226562 17 8.992188 C 17 11.757812 14.761719 13.996094 12 13.996094 Z M 12 6 C 10.339844 6 9 7.339844 9 9 C 9 10.660156 10.339844 12 12 12 C 13.660156 12 15 10.660156 15 9 C 15 7.339844 13.660156 6 12 6 Z M 12 6',
                    fillColor: '#0f0',
                    fillOpacity: 1,
                    strokeColor: '#0f2',
                    strokeWeight: 1,
                    rotation: 0,
                    scale: 1.5,
                    anchor: { x: 5, y: 10 },
                  }"
                >
                  <gmap-info-window :closeclick="true"> </gmap-info-window>
                </gmap-marker>
              </gmap-cluster>

              <gmap-marker
                v-if="firstpoint.on == true"
                ref="first_point"
                :label="{
                  text: '0 km',
                  color: theme == 'dark' ? '#e5e7eb' : '#000000',
                  fontWeight: 'bold',
                }"
                :clickable="true"
                :options="{
                  position: {
                    lat: parseFloat(firstpoint.lat),
                    lng: parseFloat(firstpoint.lng),
                  },
                }"
                :icon="{
                  url:
                    theme == 'dark'
                      ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
                      : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
                  width: 50,
                  height: 50,
                  textSize: 12,
                  anchor: { x: 14, y: 16 },
                  labelOrigin: { x: 5, y: -5 },
                }"
                @click="unsetDistanceMarker('first')"
              />
              <gmap-marker
                v-if="secondpoint.on == true"
                ref="second_point"
                :label="{
                  text: distance + ' km',
                  color: theme == 'dark' ? '#e5e7eb' : '#000000',
                  fontWeight: 'bold',
                }"
                :clickable="true"
                :options="{
                  position: {
                    lat: parseFloat(secondpoint.lat),
                    lng: parseFloat(secondpoint.lng),
                  },
                }"
                :icon="{
                  url:
                    theme == 'dark'
                      ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
                      : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
                  width: 50,
                  height: 50,
                  textSize: 12,
                  anchor: { x: 16, y: 16 },
                  labelOrigin: { x: 5, y: -5 },
                }"
                @click="unsetDistanceMarker('second')"
              />
              <gmap-polyline
                v-if="firstpoint.on == true && secondpoint.on == true"
                :options="{
                  strokeColor: theme == 'dark' ? '#9ca3af' : '#212121',
                  strokeOpacity: 0.8,
                  strokeWeight: 3,
                }"
                :path="[
                  { lat: firstpoint.lat, lng: firstpoint.lng },
                  { lat: secondpoint.lat, lng: secondpoint.lng },
                ]"
                :editable="false"
              />
              <gmap-marker
                v-if="searchAddress"
                :position="{
                  lat: parseFloat(searchAddress.latitude),
                  lng: parseFloat(searchAddress.longitude),
                }"
              >
                <gmap-info-window :closeclick="true">
                  {{ formatAddr }}
                </gmap-info-window>
              </gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CctvService from "@/helpers/cctv.service";
import { gmapApi } from "vue2-google-maps";
import VideoPlayer from "../../../components/widgets/video-player.vue";
// import VueGoogleAutocomplete from "vue-google-autocomplete";

/**
 * Google-map component
 */
export default {
  page: {
    title: "Google Map",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VideoPlayer },
  data() {
    let clusterStyles = [
      {
        url: require("@/assets/images/rec50.png"),
        width: 50,
        height: 50,
        textSize: 12,
        textColor: "#fff",
        anchorText: [0, 0],
      },
    ];
    return {
      title: this.$t("menuitems.visual.text"),
      items: [
        {
          text: this.$t("menuitems.visual.text"),
          href: "/visual-surveillance",
        },
        {
          text: this.$t("menuitems.apps-geo.text"),
          active: true,
        },
      ],
      center: { lat: -2.687944013464189, lng: 117.81568343337175 },
      zoom: 5,
      cctvmap: [],
      openMarkerId: "",
      activecctv: {
        cctv1: {
          is_active: false,
          lat: "",
          lng: "",
          cctvdata: {
            id: null,
            link: null,
            name: "",
          },
        },
        cctv2: {
          is_active: false,
          lat: "",
          lng: "",
          cctvdata: {
            id: null,
            link: null,
            name: "",
          },
        },
        cctv3: {
          is_active: false,
          lat: "",
          lng: "",
          cctvdata: {
            id: null,
            link: null,
            name: "",
          },
        },
        cctv4: {
          is_active: false,
          lat: "",
          lng: "",
          cctvdata: {
            id: null,
            link: null,
            name: "",
          },
        },
        cctv5: {
          is_active: false,
          lat: "",
          lng: "",
          cctvdata: {
            id: null,
            link: null,
            name: "",
          },
        },
      },
      clusterIcon: clusterStyles,
      showCluster: false,
      showMarker: false,
      showMarkerCluster: true,
      theme: "",
      poi: false,
      measure_distance: false,
      distance: "",
      firstpoint: {
        on: false,
        lat: 0,
        lng: 0,
      },
      secondpoint: {
        on: false,
        lat: 0,
        lng: 0,
      },
      hls: {
        cctv1: false,
        cctv2: false,
        cctv3: false,
        cctv4: false,
        cctv5: false,
      },
      playerOptions: {
        height: "150px",
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
      },
      playerOptionsModal: {
        autoplay: true,
        controls: true,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
      },
      searchAddress: null,
      formatAddr: "",
    };
  },
  computed: {
    player1() {
      return this.$refs.videoPlayer1.player;
    },
    player2() {
      return this.$refs.videoPlayer2.player;
    },
    player3() {
      return this.$refs.videoPlayer3.player;
    },
    player4() {
      return this.$refs.videoPlayer4.player;
    },
    player5() {
      return this.$refs.videoPlayer5.player;
    },
    player1modal() {
      return this.$refs.videoPlayer1Modal.player;
    },
    player2modal() {
      return this.$refs.videoPlayer2Modal.player;
    },
    player3modal() {
      return this.$refs.videoPlayer3Modal.player;
    },
    player4modal() {
      return this.$refs.videoPlayer4Modal.player;
    },
    player5modal() {
      return this.$refs.videoPlayer5Modal.player;
    },
    google: gmapApi,
  },
  methods: {
    test2(e) {
      console.log("tesst 2 ==> ", e);
    },
    test(zoom) {
      console.log("zoom test -> ", zoom);
      if (zoom > 7) {
        this.showCluster = true;
      } else {
        this.showCluster = false;
      }
      if (zoom > 14) {
        this.showMarker = true;
      } else {
        this.showMarker = false;
      }
      if (zoom >= 19) {
        this.showMarkerCluster = false;
      } else {
        this.showMarkerCluster = true;
      }
    },
    videoModal(cctv, link) {
      setTimeout(() => {
        this.playVideoModal(cctv, link);
      }, 500);
    },
    playVideoModal(idplayer, source) {
      const video = {
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source,
      };
      if (idplayer == 1) {
        this.player1modal.reset();
        this.player1modal.src(video);
        this.player1modal.play();
      } else if (idplayer == 2) {
        this.player2modal.reset();
        this.player2modal.src(video);
        this.player2modal.play();
      } else if (idplayer == 3) {
        this.player3modal.reset();
        this.player3modal.src(video);
        this.player3modal.play();
      } else if (idplayer == 4) {
        this.player4modal.reset();
        this.player4modal.src(video);
        this.player4modal.play();
      } else {
        this.player5modal.reset();
        this.player5modal.src(video);
        this.player5modal.play();
      }
    },
    playVideo(idplayer, source) {
      const video = {
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source,
      };
      if (idplayer == 1) {
        this.player1.reset();
        this.player1.src(video);
        this.player1.play();
      } else if (idplayer == 2) {
        this.player2.reset();
        this.player2.src(video);
        this.player2.play();
      } else if (idplayer == 3) {
        this.player3.reset();
        this.player3.src(video);
        this.player3.play();
      } else if (idplayer == 4) {
        this.player4.reset();
        this.player4.src(video);
        this.player4.play();
      } else {
        this.player5.reset();
        this.player5.src(video);
        this.player5.play();
      }
    },
    imageError(cctv, link) {
      switch (cctv) {
        case "cctv1":
          this.hls.cctv1 = true;
          setTimeout(() => {
            this.playVideo(1, link);
          }, 800);
          break;
        case "cctv2":
          this.hls.cctv2 = true;
          setTimeout(() => {
            this.playVideo(2, link);
          }, 800);
          break;
        case "cctv3":
          this.hls.cctv3 = true;
          setTimeout(() => {
            this.playVideo(3, link);
          }, 800);
          break;
        case "cctv4":
          this.hls.cctv4 = true;
          setTimeout(() => {
            this.playVideo(4, link);
          }, 800);
          break;
        case "cctv5":
          this.hls.cctv5 = true;
          setTimeout(() => {
            this.playVideo(5, link);
          }, 800);
          break;
        default:
          break;
      }
    },
    getCctvMap() {
      CctvService.map()
        .then((response) => {
          this.cctvmap = response.data.data;
        })
        .catch((e) => {
          console.log(e.response.data.data);
        });
    },
    openMarker(id, lat, lng, zoom) {
      this.openMarkerId = id;
      // this.center = {lat : parseFloat(lat), lng : parseFloat(lng)};
      // this.zoom = zoom
    },
    setChecked(id) {
      if (this.activecctv.cctv1.cctvdata.id == id) {
        return true;
      } else if (this.activecctv.cctv2.cctvdata.id == id) {
        return true;
      } else if (this.activecctv.cctv3.cctvdata.id == id) {
        return true;
      } else if (this.activecctv.cctv4.cctvdata.id == id) {
        return true;
      } else if (this.activecctv.cctv5.cctvdata.id == id) {
        return true;
      } else {
        return false;
      }
    },
    setActive(id, link, name, lat, lng) {
      console.log("active ==> ", this.$refs.mymap);
      let slot = this._checkemptycctv();
      switch (slot) {
        case "cctv1":
          this.activecctv.cctv1.is_active = true;
          this.activecctv.cctv1.lat = lat;
          this.activecctv.cctv1.lng = lng;
          this.activecctv.cctv1.cctvdata.id = id;
          this.activecctv.cctv1.cctvdata.link = link;
          this.activecctv.cctv1.cctvdata.name = name;
          break;
        case "cctv2":
          this.activecctv.cctv2.is_active = true;
          this.activecctv.cctv2.lat = lat;
          this.activecctv.cctv2.lng = lng;
          this.activecctv.cctv2.cctvdata.id = id;
          this.activecctv.cctv2.cctvdata.link = link;
          this.activecctv.cctv2.cctvdata.name = name;
          break;
        case "cctv3":
          this.activecctv.cctv3.is_active = true;
          this.activecctv.cctv3.lat = lat;
          this.activecctv.cctv3.lng = lng;
          this.activecctv.cctv3.cctvdata.id = id;
          this.activecctv.cctv3.cctvdata.link = link;
          this.activecctv.cctv3.cctvdata.name = name;
          break;
        case "cctv4":
          this.activecctv.cctv4.is_active = true;
          this.activecctv.cctv4.lat = lat;
          this.activecctv.cctv4.lng = lng;
          this.activecctv.cctv4.cctvdata.id = id;
          this.activecctv.cctv4.cctvdata.link = link;
          this.activecctv.cctv4.cctvdata.name = name;
          break;
        case "cctv5":
          this.activecctv.cctv5.is_active = true;
          this.activecctv.cctv5.lat = lat;
          this.activecctv.cctv5.lng = lng;
          this.activecctv.cctv5.cctvdata.id = id;
          this.activecctv.cctv5.cctvdata.link = link;
          this.activecctv.cctv5.cctvdata.name = name;
          break;
        default:
          this.alert = true;
          break;
      }
    },
    setNonActive(id) {
      console.log("non active ==> ", this.$refs.mymap);
      let active = this._checkactivecctv(id);
      switch (active) {
        case "cctv1":
          this.activecctv.cctv1.is_active = false;
          this.activecctv.cctv1.cctvdata = [];
          this.hls.cctv1 = false;
          break;
        case "cctv2":
          this.activecctv.cctv2.is_active = false;
          this.activecctv.cctv2.cctvdata = [];
          this.hls.cctv2 = false;
          break;
        case "cctv3":
          this.activecctv.cctv3.is_active = false;
          this.activecctv.cctv3.cctvdata = [];
          this.hls.cctv3 = false;
          break;
        case "cctv4":
          this.activecctv.cctv4.is_active = false;
          this.activecctv.cctv4.cctvdata = [];
          this.hls.cctv4 = false;
          break;
        case "cctv5":
          this.activecctv.cctv5.is_active = false;
          this.activecctv.cctv5.cctvdata = [];
          this.hls.cctv5 = false;
          break;
        default:
          break;
      }
    },
    _checkemptycctv() {
      if (this.activecctv.cctv1.is_active == false) {
        return "cctv1";
      } else if (this.activecctv.cctv2.is_active == false) {
        return "cctv2";
      } else if (this.activecctv.cctv3.is_active == false) {
        return "cctv3";
      } else if (this.activecctv.cctv4.is_active == false) {
        return "cctv4";
      } else if (this.activecctv.cctv5.is_active == false) {
        return "cctv5";
      } else {
        return null;
      }
    },
    _checkactivecctv(id) {
      if (this.activecctv.cctv1.cctvdata.id == id) {
        return "cctv1";
      } else if (this.activecctv.cctv2.cctvdata.id == id) {
        return "cctv2";
      } else if (this.activecctv.cctv3.cctvdata.id == id) {
        return "cctv3";
      } else if (this.activecctv.cctv4.cctvdata.id == id) {
        return "cctv4";
      } else if (this.activecctv.cctv5.cctvdata.id == id) {
        return "cctv5";
      } else {
        return null;
      }
    },
    setColor(id) {
      if (this.activecctv.cctv1.cctvdata.id == id) {
        return ["#0067AC", "#00426e"];
      } else if (this.activecctv.cctv2.cctvdata.id == id) {
        return ["#34C38F", "#167d58"];
      } else if (this.activecctv.cctv3.cctvdata.id == id) {
        return ["#f1b44c", "#a17935"];
      } else if (this.activecctv.cctv4.cctvdata.id == id) {
        return ["#6f42c1", "#5f35ab"];
      } else if (this.activecctv.cctv5.cctvdata.id == id) {
        return ["#03ccfe", "#0285a6"];
      } else {
        return this.theme == "dark"
          ? ["#EA4335", "#B22110"]
          : ["#EA4335", "#B22110"];
      }
    },
    mapTheme() {
      let darkMode = {
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      };

      let lightMode = {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
        ],
      };

      if (this.theme != "dark") {
        return lightMode;
      } else {
        return darkMode;
      }
    },
    trafficMode() {
      this.$refs.mymap.$mapPromise.then((map) => {
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);
      });
    },
    setControl() {
      const centerControlDiv = this.$refs.custom;
      this.$refs.mymap.$mapPromise.then((map) => {
        map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
          centerControlDiv
        );
      });
      const searchControlDiv = this.$refs.search_map;
      this.$refs.mymap.$mapPromise.then((map) => {
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(
          searchControlDiv
        );
      });
    },
    poiView() {
      if (this.poi == true) {
        this.poi = false;
      } else {
        this.poi = true;
      }
    },
    measureDistance(event) {
      if (this.measure_distance == true) {
        this.setDistanceMarker(event.latLng.lat(), event.latLng.lng());
      }
    },
    getDistance() {
      const latA = parseFloat(this.firstpoint.lat);
      const lngA = parseFloat(this.firstpoint.lng);
      const latB = parseFloat(this.secondpoint.lat);
      const lngB = parseFloat(this.secondpoint.lng);
      let d = (
        google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(latA, lngA),
          new google.maps.LatLng(latB, lngB)
        ) / 1000
      ).toFixed(2);
      this.distance = d;
    },
    setDistanceMarker(lat, lng) {
      if (this.firstpoint.on == false) {
        this.firstpoint.on = true;
        this.firstpoint.lat = lat;
        this.firstpoint.lng = lng;
      } else if (this.secondpoint.on == false) {
        this.secondpoint.on = true;
        this.secondpoint.lat = lat;
        this.secondpoint.lng = lng;
      } else {
        this.resetDistanceMarker();
      }

      this.getDistance();
    },
    unsetDistanceMarker(point) {
      if (point == "first") {
        this.firstpoint.on = false;
        this.firstpoint.lat = 0;
        this.firstpoint.lng = 0;
      } else if (point == "second") {
        this.secondpoint.on = false;
        this.secondpoint.lat = 0;
        this.secondpoint.lng = 0;
      }
    },
    resetDistanceMarker() {
      this.firstpoint.on = false;
      this.firstpoint.lat = 0;
      this.firstpoint.lng = 0;
      this.secondpoint.on = false;
      this.secondpoint.lat = 0;
      this.secondpoint.lng = 0;
    },
    distanceMode() {
      if (this.measure_distance == true) {
        this.measure_distance = false;
        this.resetDistanceMarker();
      } else {
        this.measure_distance = true;
      }
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.formatAddr = addressData.formatted_address;
      this.searchAddress = addressData.formatted_address;
      this.center.lat = parseFloat(addressData.geometry.location.lat());
      this.center.lng = parseFloat(addressData.geometry.location.lng());
      this.zoom = 15;
    },
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    this.getCctvMap();
    this.trafficMode();
    this.setControl();
  },
};
</script>
<style>
.cursor-pointer:hover {
  cursor: pointer;
}
</style>
